

import React, { memo } from 'react';
import SingleValueAddon from '../../components/SingleValueAddon';
import { DURATIONS as DURATION_VALUES } from '../../../../constants/durations';








function Duration({
  duration,
  onChangeAddon,
  DURATIONS,
  disabled
}) {
  return (
    <SingleValueAddon
      options={DURATIONS}
      addonValue={duration === DURATION_VALUES.STANDARD ? void 0 : duration}
      title="Longform Edit"
      subtitle="Select a final edit block length. Allow up to 72 hours."
      onChangeAddon={onChangeAddon('DURATION')}
      disabled={disabled}
      suffixDoubleDagger />);


}

export default memo(Duration);